"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getPatchFromStateKeyAndPayload = getPatchFromStateKeyAndPayload;
exports["default"] = exports.getSuccessState = void 0;

var _getStateKeyFromConfig = _interopRequireDefault(require("../../fetch/stateKey/getStateKeyFromConfig"));

var _status = require("../../fetch/status");

var _getNormalizedDeletedState = _interopRequireDefault(require("../../normalize/getNormalizedDeletedState"));

var _getNormalizedMergedState = _interopRequireDefault(require("../../normalize/getNormalizedMergedState"));

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

function getPatchFromStateKeyAndPayload(stateKey, payload) {
  var datum = payload.datum;
  var data = payload.data;

  if (!data) {
    if (datum) {
      data = [datum];
    } else {
      data = [];
    }
  }

  var patch = _defineProperty({}, stateKey, data);

  return patch;
}

var getSuccessState = function getSuccessState(state, action) {
  var config = action.config,
      payload = action.payload;
  var status = payload.status;
  var method = config.method,
      normalizer = config.normalizer;
  var stateKey = (0, _getStateKeyFromConfig["default"])(config);
  if (!stateKey || !_status.successStatusCodesWithDataOrDatum.includes(status)) return {};
  var patch = getPatchFromStateKeyAndPayload(stateKey, payload);
  var normalizerConfig = Object.assign({
    normalizer: normalizer
  }, config);

  if (normalizer) {
    normalizerConfig.normalizer = _defineProperty({}, stateKey, {
      normalizer: normalizer,
      stateKey: stateKey
    });
  }

  return method === 'DELETE' ? (0, _getNormalizedDeletedState["default"])(state, patch, normalizerConfig) : (0, _getNormalizedMergedState["default"])(state, patch, normalizerConfig);
};

exports.getSuccessState = getSuccessState;
var _default = getSuccessState;
exports["default"] = _default;